module.exports = __webpack_public_path__ + "static/img/BWF-Logo-Text-Sizedw.28eeac3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/BWF-Logo-Text-Sizedw.png
// module id = rlf0
// module chunks = 1